import type { ApiResponse } from '@troon/api-client-deprecated';
import type { AuthUser } from '@troon/api-web-client';

type AccessProductType = NonNullable<AuthUser['troonAccessProductType']>;
type TeeTimeRateType = NonNullable<
	ApiResponse<'get', '/v1/tee-times/{teeTimeId}'>['reservationInfo']
>['rates'][number]['rateType'];
type AccessRateType = Extract<TeeTimeRateType, 'TROON_ACCESS' | 'TROON_ACCESS_PLUS'>;

const productBookingRank: Record<AccessProductType, number> = {
	TROON_ACCESS: 0,
	TROON_ACCESS_PLUS: 1,
	TROON_ACCESS_ELITE: 1,
};

const rateBookingRank: Record<AccessRateType, number> = {
	TROON_ACCESS: 0,
	TROON_ACCESS_PLUS: 1,
};

export const productName = {
	TROON_ACCESS: 'Access Premium',
	TROON_ACCESS_PLUS: 'Access Premium+',
	TROON_ACCESS_ELITE: 'Access Premium Elite',
} as const;

export function isAccessRateType(rateType: TeeTimeRateType | null | undefined): rateType is AccessRateType {
	return rateType === 'TROON_ACCESS' || rateType === 'TROON_ACCESS_PLUS';
}

export function canBookRate(
	productType: AccessProductType | null | undefined,
	rateType: TeeTimeRateType | null | undefined,
) {
	return !isAccessRateType(rateType) || (!!productType && productBookingRank[productType] >= rateBookingRank[rateType]);
}
